import { render, staticRenderFns } from "./TabelPermohonanPKPN.vue?vue&type=template&id=5d05c4bd&scoped=true&"
import script from "./TabelPermohonanPKPN.vue?vue&type=script&lang=js&"
export * from "./TabelPermohonanPKPN.vue?vue&type=script&lang=js&"
import style0 from "./TabelPermohonanPKPN.vue?vue&type=style&index=0&id=5d05c4bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d05c4bd",
  null
  
)

export default component.exports